import { Pagination } from 'shared/domains/common-ui';
import { useSearchContext } from '../SearchProvider';
export function SearchResultsPagination(props) {
    const { totalCount, limit, disabled } = props;
    const { values, setOffset } = useSearchContext();
    const { offset } = values;
    return (<Pagination count={totalCount} maxCount={10000} limit={limit} offset={offset} setOffset={setOffset} disabled={disabled}/>);
}
